/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SAPWindowUIDTOV0 } from './sAPWindowUIDTOV0';


export interface RdSAPOpeningDetailUIDTOV0 { 
    /**
     * The glazed area coverage category.
     */
    coverage?: string;
    /**
     * The proportion of the area that is multi-glazed.
     */
    multiGlazing?: number;
    /**
     * The type of glazing installed.
     */
    glazingType?: string;
    /**
     * The gap between multiple glazing layers.
     */
    glazingGap?: string;
    /**
     * Indicates if pvC window frames are installed.
     */
    upvcFramed?: boolean;
    /**
     * The U-value representing the rate of transfer of heat through a structure.
     */
    UValue?: number;
    /**
     * The solar transmittance (G-value) of the window.
     */
    GValue?: number;
    /**
     * The data source for window transmission details.
     */
    windowTransmissionDataSource?: string;
    /**
     * The percentage of openings that are draught-proofed.
     */
    draughtProofing?: number;
    /**
     * The number of open fireplaces in the property [DEPRECATED this element should not be part of the openings details].
     */
    openFireplaces?: number;
    /**
     * The type of mechanical ventilation present [DEPRECATED this element should not be part of the openings details].
     */
    ventilationType?: string;
    /**
     * Indicates if fixed air conditioning is present [DEPRECATED this element should not be part of the openings details].
     */
    fixedAirConditioning?: boolean;
    /**
     * The number of external doors.
     */
    externalDoors?: number;
    /**
     * The number of insulated external doors.
     */
    insulatedExternalDoors?: number;
    /**
     * The U-value for the insulated external doors.
     */
    doorsUValue?: number;
    /**
     * To be used when all windows are measured. Array containing measurements of all windows
     */
    sapWindows?: Array<SAPWindowUIDTOV0>;
}

